import cookies from 'browser-cookies'

const store = {}

function isWebStorageAvailable () {
    const test = 'test'
    try {
        window.localStorage.setItem(test, test)
        window.localStorage.removeItem(test)
        return true
    } catch (e) {
        return false
    }
}

const cookie = {
    all: () => cookies.all(),
    get: (key) => cookies.get(key),
    set: (key, value, options) => {
        cookies.set(key, value, options)
    },
    remove: (key) => {
        cookies.erase(key)
    }
}

const local = {
    get: (key) => {
        let value = null
        if (isWebStorageAvailable()) {
            try {
                value = JSON.parse(window.localStorage.getItem(key))
            } catch (e) {
                window.localStorage.removeItem(key)
                value = null
            }
        } else {
            value = store[key]
        }
        return value
    },
    set: (key, value) => {
        if (isWebStorageAvailable()) {
            window.localStorage.setItem(key, JSON.stringify(value))
        } else {
            store[key] = value
        }
    },
    remove: (key) => {
        if (isWebStorageAvailable()) {
            window.localStorage.removeItem(key)
        } else {
            delete store[key]
        }
    }
}

const session = {
    get: (key) => {
        let value = null
        if (isWebStorageAvailable()) {
            try {
                value = JSON.parse(window.sessionStorage.getItem(key))
            } catch (e) {
                window.sessionStorage.removeItem(key)
                value = null
            }
        } else {
            value = store[key]
        }
        return value
    },
    set: (key, value) => {
        if (isWebStorageAvailable()) {
            window.sessionStorage.setItem(key, JSON.stringify(value))
        } else {
            store[key] = value
        }
    },
    remove: (key) => {
        if (isWebStorageAvailable()) {
            window.sessionStorage.removeItem(key)
        } else {
            delete store[key]
        }
    }
}

export default {
    cookie,
    local,
    session
}
